import "./Home.css";
import { Button } from "../components/Button";
import { useState, useRef, useEffect } from "react";
import logo from "../assets/mane-logo-simple-white-1800.png";

const SERVICES = [
  "quality engineering",
  "project delivery",
  "test automation",
  "product development",
  "release management",
];

const TYPING_SPEED_MS = 80;
const DELETING_SPEED_MS = 40;
const PAUSE_MS = 1800;

export const Home = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [typed, setTyped] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [speed, setSpeed] = useState(TYPING_SPEED_MS);
  const [isReady, setIsReady] = useState(false);
  const timeoutRef = useRef();

  useEffect(() => {
    const t = setTimeout(() => setIsReady(true), 1100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!isReady) return;
    const current = SERVICES[activeIndex];
    if (!isDeleting && typed.length < current.length) {
      timeoutRef.current = setTimeout(() => {
        setTyped(current.slice(0, typed.length + 1));
        setSpeed(TYPING_SPEED_MS);
      }, speed);
    } else if (isDeleting && typed.length > 0) {
      timeoutRef.current = setTimeout(() => {
        setTyped(current.slice(0, typed.length - 1));
        setSpeed(DELETING_SPEED_MS);
      }, speed);
    } else if (!isDeleting && typed.length === current.length) {
      timeoutRef.current = setTimeout(() => setIsDeleting(true), PAUSE_MS);
    } else if (isDeleting && typed.length === 0) {
      setIsDeleting(false);
      setActiveIndex((prev) => (prev + 1) % SERVICES.length);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [typed, isDeleting, activeIndex, speed, isReady]);

  return (
    <div id="home" className="home">
      <div className="home-body">
        <div className="home-left">
          <div className="home-content">
            <h1 className="home-title">
              <span className="home-title-line">Your digital partner in</span>
              <span className="rotating-service-wrapper">
                <span className="rotating-service typewriter" key={activeIndex}>
                  {typed}
                  <span className="typewriter-cursor" aria-hidden="true" />
                </span>
              </span>
            </h1>

            <p className="home-description">
              We bring clarity to strategy and consistency to execution. Helping
              software teams ship faster, smarter with confidence and less
              chaos.
            </p>

            <div className="cta-wrapper">
              <Button href="mailto:info@maneconsultancy.be">
                Get in touch
              </Button>
            </div>
          </div>
        </div>

        <div className="home-right">
          <img src={logo} alt="Mane Consultancy Logo" className="home-logo" />
        </div>
      </div>
    </div>
  );
};
